export default __webpack_public_path__ + "static/media/lllt.0889aa28.JPG";